import {metadaApi} from '@dms/api/base';

import {
  GetPartDepartmentSettingDataApiArg,
  GetPartDepartmentSettingDataApiArgSchema,
  GetPartDepartmentSettingDataResponse,
  GetPartDepartmentSettingDataResponseSchema,
  GetPartDepartmentTypesResponse,
  GetPartDepartmentTypesResponseSchema,
  PostPartDepartmentInsertApiArg,
  PostPartDepartmentInsertApiArgSchema,
} from './types';

export const partDepartmentApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getPartDepartmentSettingData: build.query<
      GetPartDepartmentSettingDataResponse,
      GetPartDepartmentSettingDataApiArg
    >({
      query: (queryArg) => ({
        url: `/report/v1/hyundai-mobis-iris-parts-department-setting-data/${queryArg.branchId}`,
        method: 'GET',
      }),
      providesTags: ['partDepartment'],
      extraOptions: {
        requestSchema: GetPartDepartmentSettingDataApiArgSchema,
        responseSchema: GetPartDepartmentSettingDataResponseSchema,
      },
    }),
    getPartDepartmentTypes: build.query<GetPartDepartmentTypesResponse, void>({
      query: () => ({
        url: `/report/v1/hyundai-mobis-iris-parts-department/parts-departments`,
        method: 'GET',
      }),
      providesTags: ['partDepartmentTypes'],
      extraOptions: {
        responseSchema: GetPartDepartmentTypesResponseSchema,
      },
    }),
    postPartDepartmentInsert: build.mutation<void, PostPartDepartmentInsertApiArg>({
      query: (queryArg) => ({
        url: `/report/v1/parts-department/insert`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['partDepartment'],
      extraOptions: {
        requestSchema: PostPartDepartmentInsertApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetPartDepartmentSettingDataQuery,
  useLazyGetPartDepartmentSettingDataQuery,
  useGetPartDepartmentTypesQuery,
  useLazyGetPartDepartmentTypesQuery,
  usePostPartDepartmentInsertMutation,
} = partDepartmentApi;
